import React from "react";
import Link from "gatsby-link";
import styled from "react-emotion";
import { withRouter } from "react-router-dom";

import logo from "../img/mbpc-logo-white.svg";
import { colors, navbarHeight } from "../consts";
import MapSelector from "./MapSelector";

const logoSize = 180;

const Header = styled.nav`
  background-color: ${colors.primary};
  height: ${navbarHeight}px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
`;
const Logo = styled(Link)`
  display: block;
  width: ${logoSize}px;
  height: ${logoSize}px;
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  img {
    width: ${logoSize}px;
    height: ${logoSize}px;
  }
`;
const BackLink = styled.a`
  color: white;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const Navbar = ({ location, indicators }) => (
  <Header>
    <Logo to="/">
      <img src={logo} alt="Montana Rental Housing Affordability Map" />
    </Logo>
    {location.pathname !== "/" ? (
      <MapSelector indicators={indicators} />
    ) : (
      <div />
    )}
    <BackLink href="http://montanabudget.org/">
      <i className="icon-share-alt icons" /> Return to montanabudget.org
    </BackLink>
  </Header>
);

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.js